module.exports = __webpack_public_path__ + "static/media/login-bg.5641b450.png";